import { wvusLogger } from "./appLoggerV2";
import appSettings from "../settings/appSettings";

export const pagePath = window.location.pathname;

export const pathkey = `${pagePath}`;

export function getCookieVal(name: string, decodeVal: boolean = true, defaultVal: string =""): string {
  if (!window.document || !window.document.cookie) {
    return "";
  }
  const reCookieName = window.document.cookie.match(
    new RegExp("(^| )" + name + "=([^;]+)")
  );
  const cookieVal = reCookieName ? reCookieName[2] : defaultVal;

  if (decodeVal === true) {
    return decodeURIComponent(cookieVal);
  }

  return cookieVal;
}

const runOnceKeys: string[] = [];

export function runOnce(callback: () => void, uniqueKey: string): void {
  if (!runOnceKeys.includes(uniqueKey)) {
    runOnceKeys.push(uniqueKey);
    callback();
  }
}

// GPT Generated - Create function using JavaScript to dynamically add a script tag to the page head. Also provide options to add attributes for the script tag. 
export function addScriptToHead(src: string, attributes = {}): Promise<void|Error> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.setAttribute('src', src);

    // Add any additional attributes to the script tag
    if (attributes) {
      for (const key in attributes) {
        script.setAttribute(key, attributes[key]);
      }
    }

    // Resolve the Promise when the script is loaded
    script.addEventListener('load', () => {
      resolve();
    });

    // Reject the Promise if there's an error loading the script
    script.addEventListener('error', (event) => {
      const err = new Error(`Failed to load script: ${(event?.target as any)?.src}`)
      wvusLogger.log(err, wvusLogger.getLogLevelNames().ERROR);
      reject(err);
    });

    document.head.appendChild(script);
  });
}

export function addScriptsToHead(listSrc: [string, object][]) {
  return Promise
    .allSettled(listSrc.map((args) => addScriptToHead(...args)));
} 

// const mappingObject = {
//   "item_name": {
//     key: ["item_name", "name", "meta.productname"],
//     type: "string"
//   },
//   "item_id": {
//     key: ["item_id", "productid"],
//     type: "string"
//   },
//   "item_brand": {
//     key: ["item_brand", "brand"],
//     type: "string",
//     default: "",
//   },
//   "item_variant": {
//     key: ["item_variant", "variant", "pa_uom"],

//   },"monthly",
//   "item_category": "sponsorship",
//   "quantity": product.quantity || 1,
//   "price": product.price,
// }

export function getOrderApiEnv() {
  const { orderApiConfig } = appSettings;
  const orderApiBaseUrl = orderApiConfig.baseUrl; 

  let env = "prod";

  if (orderApiBaseUrl.indexOf('local') > -1) {
    env = "local";
  }
  else if (orderApiBaseUrl.indexOf('dev') > -1) {
    env = "dev";
  }
  else if (orderApiBaseUrl.indexOf('qa') > -1) {
    env = "qa";
  }
  else if (orderApiBaseUrl.indexOf('uat') > -1) {
    env = "uat";
  }

  return env; 

}

export function toDigitsOnly(input) {
  const reDigits = /([^\d]+)/g;
  return input.replace(reDigits, "");
}

export function formatPrettyPhone(inputPhone) {
  const filteredInput = toDigitsOnly(inputPhone);
  const reTelStr = /(?:(?<areacode>\d{0,3})(?:(?<prefix>\d{0,3})(?<linenumber>\d{0,4})?)?)?/g;
  const result = reTelStr.exec(filteredInput);

  if (!result?.groups) {
    return `${filteredInput.replace(/[^\d]/g, "")}`;
  }

  const { areacode="", prefix="", linenumber="" } = result.groups;

  if (!prefix) {
    return `${areacode}`;
  } else if (!linenumber) {
    return `(${areacode}) ${prefix}`;
  }

  return`(${areacode}) ${prefix}-${linenumber}`;
}

export function parseLineItemsForPhoto(lineItems) {
  let photoUrl = null;

  for ( const lineItem of lineItems ) {
    if (lineItem?.lineMeta?.wvus_product_event_donor_resources) {
      photoUrl = lineItem?.lineMeta?.wvus_product_event_donor_resources;
      break;
    }
  }

  return photoUrl;
}

export function toASCII(str) {
  const accent = 'ŠŒŽšœžŸ¥µÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýýþÿŔŕƒ';
  const noaccent = 'SOZsozYYuaaaaaaaceeeeiiiidnoooooouuuuUybsaaaaaaaceeeeiiiidnoooooouuuuyybyRra';
  let string = str;
  for (let i = 0; i < accent.length; i++) {
    string = string.replace(new RegExp(accent[i], 'g'), noaccent[i]);
  }
  string = string.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  string = string.replace(/[^\w\s]/g, '');

  return string;
}

function compareDatetimeToNowISO(dateTimeString: string): "before" | "after" | "same" {
  const inputDate = new Date(new Date(dateTimeString).toISOString()).getTime();
  const currentDate = new Date(new Date().toISOString()).getTime();
  
  if (currentDate < inputDate) {
    return "before";
  } else if (currentDate > inputDate) {
    return "after";
  } else {
    return "same";
  }
}

export function isAfterDatetime(dateTimeString: string): boolean {
  const result = compareDatetimeToNowISO(dateTimeString);
  return ['after', 'same'].includes(result);
}

export function isBeforeDatetime(dateTimeString) {
  const result = compareDatetimeToNowISO(dateTimeString);
  return ['before'].includes(result);
}

export function parseUserFriendlyMessage(errorResponse: {message: string} | undefined, defaultMsg: string =""): string {
  let userFriendlyMessage = defaultMsg;
  if (errorResponse.hasOwnProperty("message")) {
    userFriendlyMessage = errorResponse?.message || defaultMsg; 
  }

  return userFriendlyMessage; 

}

export function scrollToApp(positionSelector = "html") {
  const element = window.document.querySelector(positionSelector);

  if (element) {
    element.scrollIntoView({behavior: "smooth"});
  }
}

export const getOrderId = () => new URLSearchParams(window.location.search)?.get("order_id");

export const checkIsThankyouPage = () => !!getOrderId();

/**
 *  TODO: pair up a expiry timestamp along with the childData object stored.
 */

export const setStoredChildData = (childData, storageKey = pathkey) => {
  sessionStorage.setItem(`childData:${storageKey}`, JSON.stringify(childData));
  return childData;
}

export const getStoredChildData = (storageKey = pathkey) => {
  const storedChildData = sessionStorage.getItem(`childData:${storageKey}`);
  return storedChildData ? JSON.parse(storedChildData) : null;
}

export const removeStoredChildData = (storageKey = pathkey) => {
  sessionStorage.removeItem(`childData:${storageKey}`);
}

export function addQueryParam(name, value, useReplaceState = false) {
  addQueryParams([{name, value}], useReplaceState);
}

export function addQueryParams(paramsArray, useReplaceState = false) {
  // Get the current URL
  const currentUrl = new URL(window.location.href);

  // Get the existing query parameters
  const queryParams = new URLSearchParams(currentUrl.search);

  // Add or update the query parameters from the array
  paramsArray.forEach(({name, value}) => {
    queryParams.set(name, value);
  });

  // Create a new URL with the updated query parameters
  const newUrl = `${currentUrl.origin}${currentUrl.pathname}?${queryParams.toString()}${currentUrl.hash}`;

  // Determine whether to use pushState or replaceState
  if (useReplaceState) {
    // Replace the current URL in the browser history without adding a new entry
    window.history.replaceState({ path: newUrl }, '', newUrl);
  } else {
    // Push the new URL to the browser history without reloading the page
    window.history.pushState({ path: newUrl }, '', newUrl);
  }
}

export const removeParamsFromURL = (keysToRemove) => {
  keysToRemove = Array.isArray(keysToRemove) ? `${(keysToRemove||"")}` : [keysToRemove];
  const urlParams = new URLSearchParams(window.location.search);
  const filteredKeysToRemove = keysToRemove.filter((key) => !!urlParams.get(key));

  // Cancel If Empty
  if (!keysToRemove.length || !filteredKeysToRemove.length) {
    return;
  }

  const url = window.location.href;
  const urlParts = url.split('?');

  if (urlParts.length >= 2) {
    const queryParams = urlParts[1].split('&');
    const updatedParams = queryParams.filter(param => {
      const paramName = param.split('=')[0];
      return !keysToRemove.includes(paramName);
    });

    const updatedURL = urlParts[0] + (updatedParams.length > 0 ? '?' + updatedParams.join('&') : '');
    
    // Update the URL in the browser without reloading the page
    window.history.replaceState({}, '', updatedURL);
  }
}

export const monthNames = {
  full:[
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
],
short: [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec"
]};

export const parseDateInfo = (dateStr, displayMonthName = false) => {
  const date = new Date(dateStr);
  return [
    date.getFullYear(),
    displayMonthName && monthNames.full[date.getMonth()] || date.getMonth() + 1, 
    date.getDate(),
  ];
}

export function integerToOrdinal(number) {
  const intNumber = parseInt(number, 10);

  if (typeof intNumber !== 'number' || isNaN(intNumber) || (intNumber % 1 !== 0) || intNumber < 1) {
    return "";
  }

  const suffixes = ['th', 'st', 'nd', 'rd'];
  const remainder10 = intNumber % 10;
  const remainder100 = intNumber % 100;

  const suffix =
    remainder10 <= 3 && remainder100 !== 11 && remainder100 !== 12 && remainder100 !== 13
      ? suffixes[remainder10]
      : suffixes[0];

  return number + suffix;
}

export function getPostUploadConfirmed() {
  try {
    return JSON.parse(sessionStorage.getItem(`${window.location.pathname}:postUploadConfirmed`)) || [];
  } catch {
    // Ignore Error
    return null;
  }
}

export function hasConfirmedPostUpload(orderIdentifier) { 
  const postUploadConfirmmed = getPostUploadConfirmed();
  return Array.isArray(postUploadConfirmmed) && postUploadConfirmmed.includes(`${orderIdentifier}`);
}

export function addPostUploadConfirmed(orderIdentifier) {
  const postUploadConfirmmed = getPostUploadConfirmed();

  if (orderIdentifier && Array.isArray(postUploadConfirmmed) && !postUploadConfirmmed.includes(`${orderIdentifier}`)) {
    sessionStorage.setItem(
      `${window.location.pathname}:postUploadConfirmed`, 
      JSON.stringify([...postUploadConfirmmed, `${orderIdentifier}`])
    );
  }
}
